import { useQueryClient } from "@tanstack/react-query";
import { useMachine } from "../queries/machine/use-machine";
import { taskKeys } from "../queries/tasks/task-keys";
import { signal } from "./message";
import { useSignal } from "./use-signal";

const markingCompletedSignalFilter = (machineId?: string | null) =>
  `WorkcenterNId eq '${machineId}'`;

function markingCompletedSignal(machineId?: string | null) {
  return signal<{ d: [MarkingCompletedSignal] }>({
    enabled: !!machineId,
    app: "AppU4DM",
    channel: "APPMain_GF_MarkingCompleted",
    filters: markingCompletedSignalFilter(machineId),
  });
}

type MarkingCompletedSignal = { ProductId: string };

export function useMarkingCompletedSignal() {
  const { machine } = useMachine();
  const queryClient = useQueryClient();

  return useSignal(
    markingCompletedSignal(machine?.EquipmentNId),
    ({ d: [message] }) => {
      const key = taskKeys.getProductsWaitingForValidation(
        machine?.EquipmentNId,
        message.ProductId
      );

      return queryClient.invalidateQueries({ queryKey: key });
    }
  );
}
